(function (angular) {
    "use strict";

    var loginControllers = angular.module("controller.Login", []);

    loginControllers.controller("loginCtrl",
        ['$scope', '$rootScope', '$location', 'authenticationService', 'userService','languageService', 'localStorageService', 'storageKeys', 'appSettings', 'storeService', 'changePasswordRequestService', '$log', '$translate', '$timeout','$q','gfOIDCService','sseService','impersonationService',
            function ($scope, $rootScope, $location, authenticationService, userService, languageService, localStorageService, storageKeys, appSettings, storeService, changePasswordRequestService, $log, $translate, $timeout, $q, gfOIDCService, sseService, impersonationService) {

                $scope.showChangePasswordRequestSuccessful = false;
                $scope.showChangePasswordRequestError = false;
                $scope.showInvalidUsername = false;

                $scope.error = false;
                $scope.errorMessage = "Bad credentials";
                $scope.errorHeadder = "Error";
                $scope.errorType =  "alert-danger";
                $scope.noStoreUsers = false;

                $scope.selectedUser = 0;
                $scope.users = [];
                $scope.screenToDisplay = "";
                $scope.forgotPasswordMessage = 0;
                $scope.forgotPasswordProgressBar = false;
                $scope.formDisabled = false;
                $scope.loginPanelVisible = false;
                $scope.adminLoginPanelVisible = false;
                $scope.moveToImpersonationIfApplicable = impersonationService.redirectToImpersonationIfApplicable;

                $scope.initializeError =""
                initialize()

                function initialize () {
                    $rootScope.$on('event:auth-invalidUserLoaded', function (event, error) {
                        $log.debug("LoginController: invalid user loaded")
                        $scope.isInitializeError = true
                        $scope.initializeError = error.message
                        $scope.loginPanelVisible = false;
                        $rootScope.loginScreen.show = true
                        $rootScope.serviceRequestList.show = false
                    });

                    gfOIDCService.initialize()
                    gfOIDCService.completedLogin
                        .then(function () {
                            $log.debug('LoginController : completed login')
                            $rootScope.loginScreen.show = false
                            $rootScope.serviceRequestList.show = true
                            $rootScope.$broadcast("event:completed-login")

                            // if user is logged in the page loaded is user-login
                            // redirect to service request list
                            if(window.location.href.includes('user-login')){
                                window.location.replace(window.location.protocol + "//" + window.location.host + "/gf-servicemanager-tablet")
                            }

                            // Redirect to impersonate view once the impersonator logs out of the impersonated user context
                            var loginType =localStorageService.get(storageKeys.loginTypeKey)
                            if(loginType === appSettings.impersonationLoginType && authenticationService.isAdmin()){
                                $log.debug("trying to redirect after impersonation logout")
                                $location.path('/impersonate');
                            }

                        })
                        .catch(function (error) {
                            $log.error('LoginController : failed login ', error)
                            $rootScope.loginScreen.show = true
                            if(error.code === 403){
                                $scope.isInitializeError = true
                                $scope.initializeError = error.message
                                $scope.loginPanelVisible = false;
                            }
                            else {
                                $scope.loginPanelVisible = true;
                                $rootScope.serviceRequestList.show = false
                            }
                        });
                }

                languageService.getLocalesDisplayNames($scope.username).then(function(response){
                    $scope.currentLocaleDisplayName = response[0].displayLanguage;
                    $scope.localesDisplayNames = response;
                    $translate.use(response[0].languageCode)
                    console.log("response "+JSON.stringify(response));
                });

                if (storeService.getStore() != null) {
                    $scope.screenToDisplay = "userLogin";
                    userService.userList(storeService.getStore().id).then(function (resource) {
                        resource.$get("userList").then(function (list) {
                            $scope.users = list;
                        });
                    });
                } else {
                    $scope.screenToDisplay = "storeLogin";
                }

                $scope.credentials = {
                    username: "",
                    password: ""
                };

                $scope.storeCredentials = {
                    macDonaldsId: "",
                    password: ""
                };

                var enableForm = function() {
                    $scope.formDisabled = false;
                };
                var disableForm = function() {
                    $scope.formDisabled = true;
                };

                $scope.validateStore = function () {
                    $scope.selectedUser = 0;
                    disableForm();
                    storeService.authenticate($scope.storeCredentials).then(
                        function (storeResource) {

                            storeService.setStoreContext(storeResource);

                            storeResource.$get("users").then(function (resource) {
                                if(resource.$has("userList")) {
                                    resource.$get("userList").then(function (list) {
                                        $scope.error = false;
                                        $scope.noStoreUsers = false;
                                        $scope.users = list;
                                        $scope.screenToDisplay = "userLogin";
                                        $timeout(enableForm, 0);
                                    });
                                }else{
                                    $scope.error = true;
                                    $scope.noStoreUsers = true;
                                    /** When there are no active store users we would fall into this case.
                                     * We would know if there are no active users only after successful login into store,
                                     * when we show this error message it means we already have set the store context and
                                     * on refreshing the page it will show the goback() screen, which is not a good UX.
                                     * So we are removing the store context so that we show the store login screen on refresh
                                     **/
                                    storeService.removeStoreContext();
                                    $timeout(enableForm, 0);
                                }
                            });
                        },
                        function (status) {
                            $scope.error = true;
                            $scope.noStoreUsers = false;
                            $timeout(enableForm, 2500);
                        }
                    );
                };

                $scope.forgotPassword = function (userId,username) {
                    if($scope.formDisabled == true) {
                        return false;
                    }
                    if(userId == null && (username == null || username == "")){
                        $scope.showInvalidUsername = true;
                    }else {
                        $scope.forgotPasswordProgressBar = true;

                        changePasswordRequestService.makeRequest(userId, username).then(
                            function (response) {
                                $scope.showChangePasswordRequestSuccessful = true;
                                $scope.forgotPasswordProgressBar = false;
                            },
                            function (error) {
                                $scope.showChangePasswordRequestError = true;
                                $scope.forgotPasswordProgressBar = false;
                            }
                        );
                    }
                };

                $scope.logoutOfStore = function () {
                    $scope.selectedUser = 0;
                    disableForm();
                    storeService.authenticate($scope.storeCredentials).then(
                        function () {
                            storeService.removeStoreContext();
                            storeService.removeLoginType();
                            $scope.storeCredentials.macDonaldsId = "";
                            $scope.storeCredentials.password = "";
                            $scope.screenToDisplay = "storeLogin";
                            $scope.error = false;
                            $timeout(enableForm, 0);
                        },
                        function () {
                            $scope.error = true;
                            $timeout(enableForm, 2500);
                        }
                    );
                };

                $scope.goBack = function () {
                    if($scope.formDisabled == true) {
                        return false;
                    }
                    if ($scope.screenToDisplay === "userLogin") {
                        var store = localStorageService.get(storageKeys.storeKey);
                        $scope.storeCredentials = {
                            macDonaldsId: store.mcDonaldsStoreId,
                            password: ""
                        };
                        $scope.screenToDisplay = "storeLogout";
                        $scope.error = false;
                    } else {
                        $scope.screenToDisplay = "userLogin";
                        $scope.error = false;
                    }
                };

                $scope.setUser = function (id, username) {
                    $scope.showChangePasswordRequestSuccessful = false;
                    $scope.selectedUser = id;
                    $scope.credentials.username = username;
                };

                $scope.login = function (mode) {
                    $scope.error = false
                    $scope.formDisabled = true
                    console.log("mode "+mode );
                    if (mode === appSettings.storeLoginType) {
                        console.log("store mode");
                        localStorageService.set(storageKeys.loginTypeKey, appSettings.storeLoginType);
                    }
                    //else if (authenticationService.userHasRole(appSettings.engineerRole)) {
                    else if (mode === appSettings.engineerRole) {
                        console.log("engineer mode");
                        localStorageService.set(storageKeys.loginTypeKey, appSettings.engineerRole);
                    }else {
                        console.log("gonna logout");
                        //sseService.delete();           //commented it to test ES-4878
                        gfOIDCService.logout();
                        $scope.errorHeadder = "Warning";
                        $scope.error = true;
                        $scope.errorMessage = $translate.instant('label.controller.services.loginController.NotAuthorised');
                        $scope.errorType =  "alert-warning";
                        $timeout(enableForm, 2500);
                    }

                    gfOIDCService.getNewToken($scope.credentials.username);
                }
            }]);

    loginControllers.controller("logoutCtrl", ['$scope', 'gfOIDCService', 'localStorageService', 'storageKeys', 'appSettings','storeService','$log','sseService','impersonationService',
        function ($scope, gfOIDCService, localStorageService, storageKeys, appSettings, storeService, $log, sseService, impersonationService) {

            $scope.logout = function () {
                //sseService.delete();           //commented it to test ES-4878
                gfOIDCService.logout();
                if(localStorageService.get(storageKeys.loginTypeKey) === appSettings.impersonationLoginType) {
                    impersonationService.removeImpersonationContext();
                }
            };

            $scope.exitImpersonation = function(){
                gfOIDCService.impersonate();
            };
        }]);

    loginControllers.controller("loginProfileCtrl", ['$scope', '$rootScope', '$location', 'localStorageService', '$translate', 'storageKeys', 'languageService', 'userService', 'filterFilter', 'storeService', 'clockService','configuration','$window','$log',
        function ($scope, $rootScope, $location, localStorageService, $translate, storageKeys, languageService, userService, filterFilter, storeService, clockService, configuration, $window, $log) {

            $scope.redirectToEtechTasksStore = redirectToEtechTasksStore
            $scope.profile = {
                id: 0,
                firstName: "",
                lastName: "",
                roles: []
            };

            $scope.localesDisplayNames=[];
            $scope.username = "";

            $scope.store = storeService.getStore();
            $scope.storeMode = storeService.isStoreMode();
            $scope.tasksIntegrated = configuration.tasksIntegrated;

            var profile = localStorageService.get(storageKeys.profileKey);

            if (profile) $scope.profile = profile;

            $rootScope.$on('event:completed-login', function () {
                $scope.profile =  localStorageService.get(storageKeys.profileKey);
                $scope.store = storeService.getStore();
                clockService.getAppDateFormat().then(function (response) {
                    var dateTimeFormat = response.dateTimeFormat;
                    $scope.appDateTimeFormat = dateTimeFormat;
                    $scope.appDateFormat = dateTimeFormat.substring(0, dateTimeFormat.indexOf(' '));

                    localStorageService.set(storageKeys.appDateTimeFormat, dateTimeFormat);
                    localStorageService.set(storageKeys.appDateFormat, $scope.appDateFormat);
                });
            });

            $scope.isUserImpersonated =function(){
                return localStorageService.get(storageKeys.impersonatedKey);
            }

            $scope.hasUserRole = function (role) {
                var found = filterFilter($scope.profile.roles, role);
                return (found.length > 0);
            };

            $scope.$on('setStoreTime', function (event, store) {
                $log.debug("loginProfileCtrl: received setStoreTime");
                clockService.getTime().then(function (response) {
                    $scope.storeTime = clockService.getTimeFromString(response.storeTime);
                });
            });

            $scope.$on('event:completed-login', function (event, store) {
                if($scope.storeMode){
                    clockService.getTime().then(function (response) {
                        $scope.storeTime = clockService.getTimeFromString(response.storeTime);
                    });
                }
                userService.profile().then(function(response){
                    $scope.username = response.username

                    languageService.getLocalesDisplayNames($scope.username).then(function(response){
                        $scope.currentLocaleDisplayName = response[0].displayLanguage;
                        $scope.localesDisplayNames = response;
                        $translate.use(response[0].languageCode)
                    });
                },function(err){
                    console.log(JSON.stringify(err));
                });
            });

            $scope.$on('setStore',function (event, store){
                $log.debug("loginProfileCtrl: received setStore");
                $scope.store = storeService.getStore();
            });

            $scope.$on('removeStoreTime', function (event) {
                    $scope.storeTime = "";
            });
            // detect etech tasks store redirect flow
            // if etech tasks store is not logged in it will redirect to etech vegas tablet for login
            var etechTasksStoreRedirectPathIdx = $location.url().indexOf("redirect=")
            if (etechTasksStoreRedirectPathIdx !== -1) {
                var etechTasksStoreRedirectPath = $location.url().substr(etechTasksStoreRedirectPathIdx + "redirect=".length)
                localStorageService.set(storageKeys.etechTasksStoreRedirectUriKey, etechTasksStoreRedirectPath)
            }

            // after login detect if tasks admin redirect flow is in progress
            var etechTasksStoreRedirectPath = localStorageService.get(storageKeys.etechTasksStoreRedirectUriKey)
            if ($location.url().indexOf("redirect=") === -1 && etechTasksStoreRedirectPath !== null) {
                $log.debug("auth: detected etech tasks redirect, serializing store and redirecting to etech tasks admin")
                localStorageService.remove(storageKeys.etechTasksStoreRedirectUriKey)
                var decodedPath = decodeURIComponent(etechTasksStoreRedirectPath)
                var store = localStorageService.get(storageKeys.storeKey);
                // remove sensitive data
                delete store.storeAuthentication
                // serialize data, append to redirect url and redirect

                $window.location.href = decodedPath + "?store=true&" + $.param(store)
            }
            function redirectToEtechTasksStore() {
                var store = localStorageService.get(storageKeys.storeKey);
                // remove sensitive data
                delete store.storeAuthentication
                // serialize data, append to redirect url and redirect
                $window.location.href = configuration.etechTasksTabletUri  + "/#/tasks#?store=" + $.param(store)
            }
            $scope.changeLanguage = function (locale) {
                languageService.setLocaleByDisplayName(locale);
                userService.persistLanguage(locale).then(function(response){
                    $scope.currentLocaleDisplayName = response.displayLanguage;
                });
            };
        }]);
})(angular);